import { Card } from "antd";
import React, { useCallback, useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { industriesToChart } from "./industries-to-chart";
import { ChartDataFeedback } from "../../chart-data-feedback";
import { useCompaniesByDimensions } from "../use-companies-by-dimensions";
import { INDUSTRIES_CHART_OPTIONS } from "./industries-chart-options";

export const IndustryChart = ({ filters = {} }) => {
  const { loading, results } = useCompaniesByDimensions({
    dimensions: ["companyIndustry"],
    mustBeSet: ["companyIndustry"],
    ...filters
  });

  const chartData = useMemo(() => {
    if (!results) return ({ labels: [], datasets: [] });

    const [result] = results;
    return industriesToChart(result.data);
  }, [results]);

  const getFontSize = useCallback(() => {
    if (chartData?.labels?.length > 40) return 5;
    return undefined;
  }, [chartData]);

  INDUSTRIES_CHART_OPTIONS.scales.x.ticks.font.size = getFontSize();

  return (
    <Card
      spaced
      bordered
      style={sectionStyle}
      bodyStyle={{ height: "max-content", padding: 0 }}
      title="Compañías por industria">
      <ChartDataFeedback
        loading={loading}
        isEmpty={!chartData?.datasets?.length}>
        <Bar
          data={chartData}
          type={"bar"}
          height={500}
          options={INDUSTRIES_CHART_OPTIONS} />
      </ChartDataFeedback>
    </Card>
  );
};

const sectionStyle = {
  marginTop: 16,
  boxShadow: "none",
  borderRadius: "0"
};
